var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { useQueryClient, useMutation, useIsMutating } from "@tanstack/react-query";
import { creditAccountsCacheKey } from "@syf-api-library/credit-accounts";
import { paymentMethodsCacheKey } from "../cacheKeys.js";
import mutationFnFactory from "./mutation.js";
function usePaymentMethodsMutation({
  config,
  keyProps,
  mutationOptions = {}
}) {
  const queryClient = useQueryClient();
  return useMutation(__spreadValues({
    mutationKey: paymentMethodsCacheKey(keyProps),
    mutationFn: mutationFnFactory(config, keyProps),
    onSuccess: () => {
      const selfCacheKey = paymentMethodsCacheKey(keyProps);
      const creditAccountsQuery = queryClient.getQueryData(
        creditAccountsCacheKey()
      );
      creditAccountsQuery == null ? void 0 : creditAccountsQuery.accounts.forEach((creditAccount) => {
        const accountId = creditAccount.info["cipher.accountId"];
        if (accountId !== keyProps.accountId) {
          const accountKeyProps = {
            accountId,
            accountIdType: keyProps.accountIdType
          };
          const queryKey = paymentMethodsCacheKey(accountKeyProps);
          queryClient.invalidateQueries(queryKey);
        }
      });
      return queryClient.invalidateQueries(selfCacheKey);
    }
  }, mutationOptions));
}
const useIsPaymentMethodsMutating = ({
  keyProps
}) => {
  return useIsMutating(paymentMethodsCacheKey(keyProps)) > 0;
};
export {
  useIsPaymentMethodsMutating,
  usePaymentMethodsMutation
};
//# sourceMappingURL=paymentMethodsMutation.js.map
